<template>
  <div class="gift_points_box">
    <div class="header">{{ $_translations.value.common_reward_header }}</div>

    <div class="flex-row">
      <BaseImage
        :src="prizeTypeImage"
        alt="Reward"
        image-class="points_img"
      />

      <p class="points">{{ __prizeValue }} {{ $_translations.value[prizeTypeText] }}</p>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import BaseImage from '@/components/image/BaseImage.vue';
import { isPositiveNumber } from '@/helpers/common.js';
import { rewardPrizeTypeEnum } from '@/constants/reward.js';
import { gamesImage, pointsImage } from '@/constants/image.js';

const props = defineProps({
  prizeValue: {
    type: Number,
    default: 0,
  },
  prizeType: {
    type: String,
    default: rewardPrizeTypeEnum.POINTS,
    validator: (value) => Object.values(rewardPrizeTypeEnum).includes(value),
  },
});

const __prizeValue = computed(() => isPositiveNumber(props.prizeValue) ? `+${ props.prizeValue }` : props.prizeValue);

const prizeTypeImage = computed(() => {
  switch (props.prizeType) {
    case rewardPrizeTypeEnum.GAMES:
      return gamesImage;
    case rewardPrizeTypeEnum.POINTS:
      return pointsImage;
    default:
      return '';
  }
});

const prizeTypeText = computed(() => {
  switch (props.prizeType) {
    case rewardPrizeTypeEnum.GAMES:
      return props.prizeValue === 1 ? 'common_reward_game' : 'common_reward_game_plural';
    case rewardPrizeTypeEnum.POINTS:
      return 'common_reward_points';
    default:
      return '';
  }
});
</script>
